import React from "react";
import ReactPaginate from "react-paginate";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import "./CustomPagination.css";

const CustomPagination = ({ pageCount, handlePageClick, page }) => {
  return (
    <ReactPaginate
      nextLabel={<FontAwesomeIcon icon={faChevronRight} />}
      onPageChange={handlePageClick}
      pageRangeDisplayed={3}
      marginPagesDisplayed={2}
      pageCount={pageCount}
      forcePage={page - 1}
      previousLabel={<FontAwesomeIcon icon={faChevronLeft} />}
      pageClassName="page-item"
      pageLinkClassName="page-link"
      previousClassName="page-item-ctn"
      previousLinkClassName="page-link"
      nextClassName="page-item-ctn"
      nextLinkClassName="page-link"
      breakLabel="..."
      breakClassName="page-item"
      breakLinkClassName="page-link"
      containerClassName="pagination"
      activeClassName="active"
      renderOnZeroPageCount={null}
    />
  );
};

export default CustomPagination;
